var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRotation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94.618,
    height: 106.238,
    viewBox: "0 0 94.618 106.238",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rotation",
    transform: "translate(554.882 -350.699)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_517",
    "data-name": "Trac\\xE9 517",
    d: "M-500.226,454.609a42.062,42.062,0,0,0,16.344-1.77,43.433,43.433,0,0,0,14.909-8.209,44.946,44.946,0,0,0,10.949-13.772,46.511,46.511,0,0,0,4.963-17.479,48.01,48.01,0,0,1-2.223,18.616,49.418,49.418,0,0,1-9.493,16.831,50.9,50.9,0,0,1-15.7,12.233,52.474,52.474,0,0,1-19.752,5.415l-.1.007a5.954,5.954,0,0,1-6.371-5.508,5.956,5.956,0,0,1,5.509-6.371A6.46,6.46,0,0,1-500.226,454.609Z",
    transform: "translate(-7.347 -9.56)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_518",
    "data-name": "Trac\\xE9 518",
    d: "M-507.573,362.587a42.055,42.055,0,0,0-16.343,1.77,43.415,43.415,0,0,0-14.909,8.208,44.953,44.953,0,0,0-10.949,13.772,46.5,46.5,0,0,0-4.963,17.48,47.991,47.991,0,0,1,2.223-18.616,49.4,49.4,0,0,1,9.493-16.831,50.869,50.869,0,0,1,15.7-12.234,52.469,52.469,0,0,1,19.751-5.415l.1-.008a5.956,5.956,0,0,1,6.371,5.509,5.956,5.956,0,0,1-5.509,6.371A6.471,6.471,0,0,1-507.573,362.587Z",
    transform: "translate(0 0)",
    fill: "#ddd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotation);
export default __webpack_public_path__ + "static/media/rotation.bcd86baeb7a33eafb0a8bb9352105d9e.svg";
export { ForwardRef as ReactComponent };